import * as classes from './Testimonials.module.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Button from './Button'

const Testimonials = ({ image, ctaButton, ctaButtonSecondary, text }) => {
  if (!text) return <></>

  return (
    <section
      className={`container-text ${classes.testimonials}`}
      style={
        image
          ? {
              backgroundImage: `url(${image?.url}?fm=webp)`,
              background: 'cover',
            }
          : ''
      }
    >
      <div className={`container-sm ${classes.content}`}>
        {documentToReactComponents(text)}
      </div>
      {(ctaButton || ctaButtonSecondary) && (
        <div className={classes.ctaContainer}>
          {ctaButton && <Button button={ctaButton} />}
          {ctaButtonSecondary && <Button button={ctaButtonSecondary} />}
        </div>
      )}
    </section>
  )
}

export default Testimonials
